const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export default sleep;

export const checkIsSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
